import store from '../../store/store'

const loadQuestions = (to, from) => {
	const isSameIds = from.params.id === to.params.id
	const verifyPathTo = !!to.fullPath.match(/\/objetos\/(?!create)(\S.*)/)
	// FROM objetoQuestoes AND objetoEdit AND objetoDetalhes
	if (from.name === 'objetoQuestoes' && (to.name !== 'objetoEdit' && to.name !== 'objetoDetalhes')) {
		store.dispatch({ type: 'unloadObjectQuestions' })
		store.dispatch({ type: 'unloadTypes' })
	}

	if (from.name === 'objetoEdit' && to.name !== 'objetoQuestoes') {
		store.dispatch({ type: 'unloadObjectQuestions' })
		store.dispatch({ type: 'unloadTypes' })
	}

	if (from.name === 'objetoDetalhes') {
		// store.dispatch({ type: 'unloadObjectQuestions' })
		// store.dispatch({ type: 'unloadTypes' })
	}

	// TO  objetoQuestoes AND objetoEdit
	if (verifyPathTo && (store.getters.isEmpty) && !isSameIds) {
		store.dispatch({
			type: 'loadObjectQuestions',
			theme: to.params.id
		})
	}
}

export default loadQuestions
